export default "__VITE_ASSET__B$rZ4$zl__ 120w, __VITE_ASSET__DqIw35E9__ 240w, __VITE_ASSET__B5utBsI0__ 360w, __VITE_ASSET__H48N6oGX__ 480w";